import { HttpService } from '@/infra'
import type { TAtendimento } from '@/types/atendimento'

export type TGetAtendimentoAtivoResponse = TAtendimento | null

export class GetAtendimentoAtivoService extends HttpService {
  async execute() {
    const response = await this.http.get<TGetAtendimentoAtivoResponse>('api/v2/Atendimento/ativo')
    return response.data
  }
}
